import { IsBoolean, IsDateString, IsOptional, IsString } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

export class CreatePestControlRecordDto {
  @IsDateString()
  date!: string;

  @IsBoolean()
  @IsOptional()
  pestDetected?: boolean;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  notes?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  signatureImage?: string;
}
